import React from 'react';
import { Box, IconButton, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { Button, Colors, Icon, Text } from '@mercator-gcp/grout';
import { Spinner } from 'components/elements/Spinner';
import { FlexRow } from 'components/layout/FlexRow';

interface NoteActionsProps {
  showButtons: boolean;
  note: string;
  onSave: () => void;
  onCancel: () => void;
  onEdit: () => void;
  onDelete: (note: string) => void;
  isLoading: boolean;
  readOnly?: boolean;
}

const Actions = ({
  showButtons,
  note,
  onSave,
  onCancel,
  onEdit,
  onDelete,
  isLoading,
  readOnly,
}: NoteActionsProps) => {
  const btnRow = {
    marginTop: '8px',
    marginLeft: 'padding_8',
    visibility: showButtons ? 'visible' : 'hidden',
    opacity: showButtons ? 1 : 0,
    transition: 'opacity 0.3s',
    gap: 'padding_8',
    justifyContent: 'space-between',
  };

  const kebabMenu = { display: 'flex', alignItems: 'start' };

  const menuBtn = {
    background: 'transparent',
    _hover: {
      background: 'transparent',
    },
    _active: {
      background: 'transparent',
      borderColor: 'transparent',
    },
  };

  const menuItem = {
    _hover: { background: 'transparent' },
    _focus: { background: 'transparent', borderColor: 'transparent' },
  };
  const btnText = { pl: 'padding_4' };

  if (readOnly) {
    return null;
  }

  if (showButtons) {
    return (
      <FlexRow sx={btnRow}>
        <Button variant="secondary" onClick={onSave}>
          {isLoading ? <Spinner size="xs" /> : 'Save'}
        </Button>
        <Button variant="functional" onClick={onCancel}>
          Cancel
        </Button>
      </FlexRow>
    );
  }
  if (note) {
    return (
      <Box sx={kebabMenu}>
        <Menu>
          {/* @ts-ignore TS2590 - Chakra Menu union too complex */}
          <MenuButton
            as={IconButton}
            aria-label="Options"
            icon={<Icon name={Icon.Name.KebabMenu} fill={Colors.Black800} />}
            size="xs"
            sx={menuBtn}
          />
          <MenuList>
            <MenuItem onClick={onEdit} sx={menuItem}>
              <Icon name={Icon.Name.Pencil} />
              <Text.SmallBold sx={btnText}>Edit</Text.SmallBold>
            </MenuItem>
            <MenuItem onClick={() => onDelete(note)} sx={menuItem}>
              <Icon name={Icon.Name.Trash} fill={Colors.Tangerine700} />
              <Text.SmallBold sx={btnText}>Delete</Text.SmallBold>
            </MenuItem>
          </MenuList>
        </Menu>
      </Box>
    ) as React.ReactElement;
  }

  return null;
};

export default Actions;
